import * as React from "react"
import {joinStrings} from "../utils";

export interface Props {
	type: "info" | "success" | "warning" | "error"
	children?: React.ReactNode
}

export const Notification = (props:Props) =>
	<div className={joinStrings(['ui-corner-all', 'notify-widget', props.type])}>
		{props.children}
	</div>



// WEBPACK FOOTER //
// ./src/lib/sbhtml/notification.tsx